import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CoverImage from './CoverImage';
import '../styles/NewArrivalsMarquee.css';

function NewArrivalsMarquee() {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarqueeBooks = async () => {
      try {
        setLoading(true);
        // Try dedicated endpoint (filters out G-prefix accessions); fall back to existing one
        let data = null;
        try {
          const r = await fetch('/api/books/new-arrivals-marquee?limit=60&excludePrefix=G');
          const json = await r.json();
          if (Array.isArray(json.books)) {
            data = json.books;
          }
        } catch (_) {}

        if (!data) {
          const r = await fetch('/api/books/by-type/BK?limit=60&newArrivals=true');
          const json = await r.json();
          data = Array.isArray(json.books) ? json.books : [];
        }

        setBooks(data);
      } catch (error) {
        console.error('Error loading marquee books:', error);
        setBooks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMarqueeBooks();
  }, []);

  const tickerBooks = useMemo(() => {
    if (!books.length) {
      return [];
    }

    // Duplicate list once to create a seamless infinite loop.
    return [...books, ...books];
  }, [books]);

  const handleBookClick = (book) => {
    if (!book?.biblio_id) {
      return;
    }

    navigate(`/book/${book.biblio_id}`, { state: { from: 'home-new-arrivals-marquee' } });
  };

  return (
    <section id="home-new-arrivals-marquee" className="na-shelf" aria-label="New arrivals book shelf">
      <div className="na-shelf__header">
        <h2 className="na-shelf__title">📚 New Arrivals</h2>
        
      </div>

      {loading && <div className="na-shelf__state">Loading new arrivals...</div>}

      {!loading && books.length === 0 && (
        <div className="na-shelf__state">No new arrivals available right now.</div>
      )}

      {!loading && books.length > 0 && (
        <div className="na-shelf__track-wrap">
          <div className="na-shelf__track">
            {tickerBooks.map((book, index) => (
              <button
                key={`${book.biblio_id}-${book.accession_number || index}-${index}`}
                className="na-shelf__card"
                onClick={() => handleBookClick(book)}
                title={`Open details for ${book.title}`}
              >
                <span className="na-shelf__badge">NEW</span>
                <span className="na-shelf__cover">
                  <CoverImage
                    biblioId={book.biblio_id}
                    isbn={book.isbn}
                    alt={book.title}
                    width={110}
                    height={155}
                    sizeCode="M"
                  />
                </span>
                <span className="na-shelf__info">
                  <span className="na-shelf__book-title">{book.title}</span>
                  {book.author && <span className="na-shelf__author">{book.author}</span>}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default NewArrivalsMarquee;
